import {
  SliderImageSection,
  SliderImageSectionProps,
  useCaseType,
} from '@rimactechnology/rimac-ui-lib';

import { SliderImageSectionFragment } from '@/api';
import getCdlPublicId from '@/hooks/useCdlPublicId';

interface SliderImageProps {
  sliderImageSection?: SliderImageSectionFragment | null;
  titleMaxWidth?: number;
  nonLazyLoadImageCount?: number;
}

export default function SliderImage({
  sliderImageSection,
  titleMaxWidth,
  nonLazyLoadImageCount,
}: SliderImageProps) {
  const sliderImageSectionProps: SliderImageSectionProps = {
    titleMaxWidth,
    nonLazyLoadImageCount,
    title: sliderImageSection?.title || '',
    titleMobile: sliderImageSection?.titleMobile || '',
    anchor: sliderImageSection?.anchor || undefined,
    useCase: 'technology' as useCaseType,
    button: sliderImageSection?.button?.label
      ? {
          useCase: 'technology',
          label: sliderImageSection?.button?.label || '',
          path: sliderImageSection?.button?.path || '',
        }
      : undefined,
    cards: (sliderImageSection?.imageCardLink || []).map((card) => ({
      useCase: 'technology' as useCaseType,
      title: card?.title || '',
      description: card?.description || undefined,
      tagName: card?.tag || '',
      link: card?.link_path || undefined,
      linkLabel: card?.link_label || '',
      linkDescription: `Go to: ${card?.link_label || ''}`,
      image: {
        imgSrc: getCdlPublicId(card?.img_desktop.data?.attributes?.url || ''),
        imgSrcMobile: getCdlPublicId(
          card?.img_mobil?.data?.attributes?.url || undefined,
        ),
        alt: card?.alt || '',
        blurHash: card?.img_desktop.data?.attributes?.blurhash || undefined,
      },
    })),
    hasLargeTitle: false,
  };

  return <SliderImageSection {...sliderImageSectionProps} />;
}
